import { z } from 'zod';

export const ADJUSTMENT_REASONS = {
  loss: 'Perda',
  damage: 'Avaria',
  gift: 'Brinde',
  correction: 'Correção',
  initial: 'Saldo inicial',
  count: 'Inventário',
} as const;
export type AdjustmentReason = keyof typeof ADJUSTMENT_REASONS;

const qty = z.coerce.number().int();
const money = z.coerce.number().int().min(0).max(100_000_000);

export const listLevelsQuerySchema = z.object({
  q: z.string().trim().max(100).optional(),
  lowOnly: z.enum(['true', 'false']).optional(),
  locationId: z.string().uuid().optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});

export const inboundSchema = z.object({
  locationId: z.string().uuid().optional(),
  supplier: z.string().trim().max(120).optional(),
  /** Lançar a compra como despesa no financeiro. */
  createPayable: z.boolean().default(false),
  items: z
    .array(
      z.object({
        variantId: z.string().uuid(),
        quantity: qty.min(1, 'A quantidade deve ser maior que zero.').max(1_000_000),
        unitCostCents: money,
      }),
    )
    .min(1)
    .max(200),
});

export const adjustmentSchema = z.object({
  locationId: z.string().uuid().optional(),
  variantId: z.string().uuid(),
  quantity: qty.refine((v) => v !== 0, 'Informe uma quantidade diferente de zero.'),
  reason: z.enum(['loss', 'damage', 'gift', 'correction'], { message: 'Informe o motivo do ajuste.' }),
  note: z.string().trim().max(300).optional(),
});

export const setMinimumSchema = z.object({
  minimum: qty.min(0).max(1_000_000),
  locationId: z.string().uuid().optional(),
});

export const listMovementsQuerySchema = z.object({
  variantId: z.string().uuid().optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});

export const openCountSchema = z.object({
  locationId: z.string().uuid().optional(),
  /** Contagem parcial; sem isto, todas as variantes com estoque controlado. */
  variantIds: z.array(z.string().uuid()).max(5000).optional(),
});

export const countItemsSchema = z.object({
  items: z
    .array(
      z.union([
        z.object({ variantId: z.string().uuid(), counted: qty.min(0) }),
        /** Leitura por código de barras ou SKU. */
        z.object({ code: z.string().trim().min(1).max(60), counted: qty.min(0) }),
      ]),
    )
    .min(1)
    .max(1000),
});

export const inventoryImportSchema = z.object({
  fileKey: z.string().min(5).max(300),
  format: z.enum(['csv', 'xlsx']),
  locationId: z.string().uuid().optional(),
});
